/**
 * Bloomreach Engagement event names.
 *
 * SDK methods (IDENTIFY, ANONYMIZE, UPDATE) are mapped to dedicated brweb SDK calls
 * in bloomreachClient.ts. All other events are dispatched via brweb.track().
 *
 * @see https://documentation.bloomreach.com/data-hub/docs/sdk-integration-for-a-new-engagement-setup
 */
export const BloomreachEventNames = {
    /** Records user consent preferences. */
    CONSENT: 'consent',
    /** Identifies the customer — calls brweb.identify({ customer_uuid }). */
    IDENTIFY: 'identify',
    /** Clears customer identity — calls brweb.anonymize() on logout. */
    ANONYMIZE: 'anonymize',
    /** Updates customer properties — calls brweb.update(). */
    UPDATE: 'update',
    /** Tracks a product view on PDP or mini-PDP. */
    VIEW_ITEM: 'view_item',
    /** Tracks a category/lister page view. */
    CATEGORY_VIEW: 'view_category',
    /** Tracks a basket add or remove. */
    CART_UPDATE: 'cart_update',
};
